import {LogoutOutlined} from '@ant-design/icons';
import {Avatar, Dropdown, Menu} from 'antd';
import {useResolveEnsName} from 'eth-hooks/dapps';
import {useCallback} from 'react';
import Blockies from 'react-blockies';
import styles from './MyAddress.module.scss';

export default function Address(props: {address: string; ensProvider?: any; onLogout: () => {}}) {
  const ens = useResolveEnsName(props.ensProvider, props.address);

  const handleMenuClick = useCallback(
    ({key}) => {
      if (key === 'disconnect') {
        props.onLogout();
      }
    },
    [props],
  );

  const renderMenu = useCallback(() => {
    return (
      <Menu onClick={handleMenuClick}>
        <Menu.Item key='avatar' disabled>
          <div className={styles.menuName}>
            <Avatar icon={<Blockies seed={props.address.toLowerCase()} />} />
            &nbsp;<b>{(ens || props.address).substring(0, 12)}</b>
          </div>
        </Menu.Item>
        <Menu.Item key='disconnect' icon={<LogoutOutlined />}>
          <div className={styles.menuItem}>Disconnect</div>
        </Menu.Item>
      </Menu>
    );
  }, [ens, handleMenuClick, props.address]);

  return (
    <Dropdown overlay={renderMenu()} trigger={['click']}>
      <Avatar className={styles.avatar} icon={<Blockies seed={props.address.toLowerCase()} />} />
    </Dropdown>
  );
}
